module.exports = __webpack_public_path__ + "media/customizations/lmlcbasecamp/back-470ee67042945ebeae1e72a61b9acba8.jpg";